import { render } from "./ProfileWidget.vue?vue&type=template&id=5449d0d2&scoped=true"
import script from "./ProfileWidget.vue?vue&type=script&lang=js"
export * from "./ProfileWidget.vue?vue&type=script&lang=js"

import "./ProfileWidget.vue?vue&type=style&index=0&id=5449d0d2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5449d0d2"]])

export default __exports__